import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { Arrow, Wrapper } from './styles';
function SWWArrow(props) {
    return (_jsxs(Wrapper, { children: [_jsxs("span", { className: "h1", children: ["Book December &", _jsx("br", {}), "January too!"] }), _jsx(Arrow, { children: _jsx("img", { src: "/assets/images/arrow-horizontal-right.png", alt: "Arrow pointing to calendar" }) })] }));
}
export default SWWArrow;
